import { Cart } from '../types';
import { cartRequest } from './request';

/**
 * Reads the whole cart — lines, totals, checkout url.
 *
 * The provider's cart is not always this. A page rendered by the legacy stack carries
 * `#dm-v2-cart`, which is the *summary* groups: a line count and the search-alert flags,
 * deliberately without the lines, because serializing them costs a product and sku
 * lookup each and every page would pay it for a badge.
 *
 * So anything that draws the lines has to ask. `Cart.items` being optional in the type
 * is that distinction, not an oversight — check it rather than assume the provider's
 * cart is the full one.
 */
export type GetCartOptions = {
  /**
   * Also price the upgrade this cart qualifies for, and return it as `lightbox_deal`.
   *
   * Off by default because it is not free: the server prices an upgrade per line, which
   * costs a product load, a coupon re-pricing and a term lookup each. Ask for it at the
   * moment the answer is used — a customer committing to checkout — and not before.
   */
  includeLightboxDeal?: boolean;
};

export default async function getCart({ includeLightboxDeal }: GetCartOptions = {}): Promise<Cart> {
  const query = includeLightboxDeal ? '?include=lightbox_deal' : '';

  return cartRequest(`/services_api/storefront/v1/cart.json${query}`, { method: 'GET' });
}
